import { trimRight } from "@/regira_modules/utilities/string-utility";

// const getApiBaseUrl = (env) => {
//   switch (env) {
//     case "production":
//       return "https://webshop.orderflow.be/api";
//     case "staging":
//       return "https://webshop.orderflow.be/api";
//     default:
//       return "https://webshop.orderflow.be/api";
//   }
// };

const config = {
  version: process.env.VERSION,
  baseUrl: trimRight(process.env.BASE_URL, "/"),
  env: process.env.NODE_ENV,
  //api: getApiBaseUrl(process.env),
};

export const createConfig = (publicConfig) => {
  for (const key in publicConfig) {
    config[key] = typeof publicConfig[key][config.env] !== "undefined" ? publicConfig[key][config.env] : publicConfig[key];
  }
  return config;
};
export const useConfig = () => config;

export default config;
